// Mirror of the password policy in src/lib/auth.js (the source of truth).
// Keep these rules in sync; passwordPolicy.test.js pins the boundaries.
export const MIN_LENGTH = 15;
export const MIN_CLASSES = 3;

export function evaluatePassword(pw) {
  const s = typeof pw === "string" ? pw : "";
  const classes = {
    lower: /[a-z]/.test(s),
    upper: /[A-Z]/.test(s),
    digit: /[0-9]/.test(s),
    symbol: /[^a-zA-Z0-9]/.test(s),
  };
  const classCount = Object.values(classes).filter(Boolean).length;
  const checks = {
    minLength: s.length >= MIN_LENGTH,
    classCount: classCount >= MIN_CLASSES,
  };
  const valid = checks.minLength && checks.classCount;

  let score = 0;
  if (s.length >= 8) score++;
  if (s.length >= MIN_LENGTH) score++;
  if (classCount >= 2) score++;
  if (valid) score++;
  if (s.length === 0) score = 0;

  const label = ["Too weak", "Weak", "Fair", "Good", "Strong"][score];
  return { length: s.length, classes, checks, score, label, valid };
}
